import { setRegularSearchText } from '@/features/audiences/audiencesSlice';
import { SearchInput } from '@/global/components';
import { RootState } from '@/reducers';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

export const AudienceTableSearch: FC = () => {
  const { t } = useTranslation();

  return (
    <div className='mb-4 flex flex-col gap-1'>
      <SearchInput
        stateSelector={(state: RootState) => state.audiences.ui.regular.searchText}
        stateUpdater={setRegularSearchText}
        placeholder={t('COMMON:search')}
      />
      <p className='text-xs text-tertiary-600'>{t('audiences:table.search_subtitle')}</p>
    </div>
  );
};
